import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'

interface MetaStore {
  lastUpdatedAt: Ref<Date>
  setLastUpdatedAt: () => void
  minutesSinceLastUpdate: () => number
}

export const useMetaStore = defineStore(
  'meta',
  (): MetaStore => {
    const lastUpdatedAt = ref(new Date())

    function setLastUpdatedAt(): void {
      lastUpdatedAt.value = new Date()
    }

    function minutesSinceLastUpdate(): number {
      const nowTime = new Date()
      const lastUpdatedTime = new Date(lastUpdatedAt.value)
      const diff = nowTime.getTime() - lastUpdatedTime.getTime()
      return Math.floor(diff / 1000 / 60)
    }

    return {
      lastUpdatedAt,
      setLastUpdatedAt,
      minutesSinceLastUpdate
    }
  },
  {
    persist: true
  }
)
